import {Navigate} from 'react-router'
import type {
  Resource,
  WithResourcesPropsWithOptionalErrorT,
  WithResourcesArrayPropsWithOptionalErrorT
} from '@freckle/educator-entities/ts/common/components/with-resources'
import {
  WithResourcesInternal,
  WithResourcesArrayInternal
} from '@freckle/educator-entities/ts/common/components/with-resources'
import {Routes} from '@freckle/school/ts/common/routers/routes'

export function WithResources<T extends Resource>({
  resources,
  render,
  error = (error: Error) => {
    console.error(error)
    return <Navigate to={Routes.dashboard()} replace />
  }
}: WithResourcesPropsWithOptionalErrorT<T>) {
  return WithResourcesInternal({resources, render, error})
}

export function WithResourcesArray<T extends Resource>({
  resources,
  render,
  error = (error: Error) => {
    console.error(error)
    return <Navigate to={Routes.dashboard()} replace />
  }
}: WithResourcesArrayPropsWithOptionalErrorT<T>) {
  return WithResourcesArrayInternal({resources, render, error})
}
